import { z } from "zod";

export const centralAdminItemSchema = z.object({
    Name: z.string().optional()
});

export const centralAdminCapacityUnitSchemaFromTopologyService = z.object({
    Name: z.string().nullish(),
    ServiceFrontDoor: z.string().nullish(),
    Forest: z.string().nullish(),
    ForestAlias: z.string().nullish(),
    Region: z.string().nullish(),
    LoadBalancer: z.string().nullish(),
    Rack: z.string().nullish(),
    VIPCount: z.number().nullish(),
    ActivityState: z.string().nullish(),
    ProvisioningState: z.string().nullish(),
    SwitchState: z.string().nullish(),
    Environment: z.string().nullish(),
    Location: z.string().nullish(),
    IsAcdcFrontDoor: z.boolean().nullish(),
    ServiceInstanceType: z.string().nullish(),
    DeploymentRing: z.string().nullish(),
    Role: z.string().nullish(),
    Nag: z.string().nullish(),
    ExchangeFaultZone: z.string().nullish(),
    ServerCount: z.number().nullish(),
    IsLive: z.boolean().nullish(),
    EffectiveLiveState: z.number().nullish()
});

export const centralAdminForestSchema = centralAdminItemSchema.extend({
    ActivityState: z.string().nullish(),
    Alias: z.string().nullish(),
    DeploymentRing: z.string().nullish(),
    Region: z.string().nullish(),
    ServiceInstanceType: z.string().nullish(),
    Type: z.string().nullish(),
    Locations: z.array(z.string()).nullish()
});

export const centralAdminDagSchema = centralAdminItemSchema.extend({
    ActivityState: z.string().nullish(),
    DeploymentRing: z.string().nullish(),
    Forest: z.string().nullish(),
    ForestAlias: z.string().nullish(),
    ServiceInstanceType: z.string().nullish(),
    Region: z.string().nullish(),
    PartitionUnit: z.string().nullish(),
    MDBCount: z.number().nullish()
});

export const centralAdminLocationSchema = centralAdminItemSchema.extend({
    Region: z.string()
});

export const centralAdminRackSchema = centralAdminItemSchema.extend({
    Name: z.string().optional(),
    SwitchState: z.string().optional(),
    ActivityState: z.string().optional(),
    Router: z.string().optional(),
    LoadBalancer: z.string().optional(),
    Environment: z.string().optional(),
    CapacityUnit: z.string().optional(),
    Functionality: z.string().optional(),
    Location: z.string().optional(),
    Region: z.string().optional()
});

export const centralAdminLoadBalancerSchema = centralAdminItemSchema.extend({
    Region: z.string().optional(),
    Location: z.string().optional(),
    Rack: z.string().optional(),
    CapacityUnit: z.string().optional()
});

export const centralAdminFaultZoneSchema = centralAdminItemSchema.extend({
    Regions: z.array(z.string()).optional(),
    Locations: z.array(z.string()).optional()
});

export const centralAdminMachineSchema = centralAdminItemSchema.extend({
    Region: z.string().nullish(),
    Forest: z.string().nullish(),
    ForestAlias: z.string().nullish(),
    Site: z.string().nullish(),
    Rack: z.string().nullish(),
    Dag: z.string().nullish(),
    Pod: z.string().nullish(),
    DeploymentRing: z.string().nullish(),
    ProvisioningState: z.string().nullish(),
    MonitoringState: z.string().nullish(),
    BuildVersion: z.string().nullish(),
    WhenCreated: z.string().nullish(),
    WhenChanged: z.string().nullish(),
    CapacityUnit: z.string().nullish(),
    MachineDefinition: z.string().nullish(),
    ActivityState: z.string().nullish(),
    Location: z.string().nullish(),
    MaintenanceState: z.string().nullish(),
    SwitchState: z.string().nullish(),
    IPAddress: z.string().nullish(),
    IPV6Address: z.string().nullish(),
    MAC: z.string().nullish(),
    DigiIP: z.string().nullish(),
    SKU: z.string().nullish(),
    ServiceInstanceType: z.string().nullish(),
    WhenLeftService: z.string().nullish(),
    GfsName: z.string().nullish(),
    ExchangeFaultZone: z.string().nullish(),
    Environment: z.string().nullish()
});

export const centralAdminMapSchema = z.record(centralAdminItemSchema);

export const centralAdminCapacityUnitSchema = z.object({
    ActivityState: z.string().nullish(),
    Environment: z.string().nullish(),
    Forest: z.string().nullish(),
    ForestAlias: z.string().nullish(),
    LoadBalancer: z.string().nullish(),
    Location: z.string().nullish(),
    Name: z.string().nullish(),
    PartitionUnit: z.string().nullish(),
    ProvisioningState: z.string().nullish(),
    Rack: z.string().nullish(),
    Region: z.string().nullish(),
    ServerCount: z.string().nullish(),
    ServiceFrontDoor: z.string().nullish(),
    SwitchState: z.string().nullish(),
    VIPCount: z.string().nullish()
});

export type CentralAdminForest = z.infer<typeof centralAdminForestSchema>;
export type CentralAdminLocation = z.infer<typeof centralAdminLocationSchema>;
export type CentralAdminMachine = z.infer<typeof centralAdminMachineSchema>;
export type CentralAdminCapacityUnit = z.infer<typeof centralAdminCapacityUnitSchema>;
